"use client";

import { usePathname } from "next/navigation";
import { useEffect, useState } from "react";

export default function PageContent({
  children,
}: {
  children: React.ReactNode;
}) {
  const pathname = usePathname();
  const isHomePage =
    pathname === "/" || (pathname?.match(/^\/[a-z]{2}\/?$/) ?? false);

  // Определяем класс на клиенте БЕЗ useEffect для синхронного рендера
  const paddingClass = isHomePage ? "pt-navbar-home" : "pt-navbar-default";

  return (
    <main id="page-content" className={paddingClass} suppressHydrationWarning>
      {children}
    </main>
  );
}
